import React from "react";
import dateformat from "dateformat";
import cx from "classnames";
import TimeAgo from "react-timeago";
import {
  Row,
  Col,
  Collapse,
  OverlayTrigger,
  Tooltip,
  Accordion,
  Card,
  Button,
} from "react-bootstrap";

import { FileService } from "src/utils/file.service";
import AssetShareView from "../contactAssetShare";
import SectionShareView from "../sectionShare/view";

import styles from "./styles.module.scss";
import Text from "src/components/text";

class SharesView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loadAnalytics: false,

      viewMore: false,
    };

    this._handleShareClicked = this._handleShareClicked.bind(this);
  }

  fetchAssetAnalytics(sectionID, asset) {
    this.props
      .fetchAssetAnalytics(
        this.props.contact,
        this.props.share.id,
        sectionID,
        asset.id
      )
      .then(() => {
        if (FileService.hasPageAnalytics(asset.metadata)) {
          if (this.props.preview && this.props.preview.item) {
            return;
          }

          this.props.fetchPreviewAsset(asset.id);
        }
      });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.id != nextProps.id) {
      this.setState({
        loadAnalytics: false,
      });
    }
  }

  _handleShareClicked() {
    if (this.props.share && this.props.share.fetchedChildren) {
      return;
    }

    this.props.fetchShareForContact(this.props.contact, this.props.id);
  }

  render() {
    if (!this.props.share) {
      return false;
    }


    var emailOpenEvent = null;
    var linkClickedEvent = null;
    var collectionViewedEvent = null;
    var collectionResharedEvent = null;

    if (this.props.share.events) {
      this.props.share.events.forEach((event) => {
        switch (event.type) {
          case "email_open":
            emailOpenEvent = event;
            break;
          case "link_clicked":
            linkClickedEvent = event;
            break;
          case "collection_viewed":
            collectionViewedEvent = event;
            break;
          case "collection_reshared":
            collectionResharedEvent = event;
          default:
            break;
        }
      });
    }

    var assetsCount = this.props.share.assetsCount;
    const viewEvent = this.getViewedEvent(this.props.share.events);
    const emailEvent = this.getEmailOpenEvent(this.props.share.events);

    var header = (
      <Row className={styles.share} onClick={() => {
        this.setState({ viewMore: !this.state.viewMore });
      }}>
        <Col md={8} className={styles.name}>
          <div className={styles.icon}>
            {this.state.viewMore ? (
              <span className="paperflite-minus" aria-hidden="true" />
            ) : (
              <span className="paperflite-add" aria-hidden="true" />
            )}
          </div>

          <div className={styles.rightTopContainer}>
            <div className={styles.horizontalFlexContainer}>
              <div className={styles.flexContainer}>
                <Text className={styles.shareName} lines={1} text={this.props.share.name || "(No Subject)"} />
                <div>
                  <div className={styles.assetsCount}>
                    {assetsCount} Asset{assetsCount > 1 && "s"}
                  </div>
                  <div className={cx(styles.assetsCount, styles.shareSource)}>
                    {this.props.share.source}
                  </div>
                </div>
              </div>
              <a
                target="_blank"
                href={`/conversations/${this.props.share.id}`}
                className={styles.previewConversationContainer}
              >
                <div className={styles.previewConversation}>
                  <i className={cx("paperflite-eye", styles.previewIcon)} />
                  PREVIEW
                </div>
              </a>
            </div>
          </div>

          
        </Col>

          <div className={styles.rightBottomContainer}>
            <div className={styles.sharedDate}>
              Shared <TimeAgo date={this.props.share.sharedDate} /> by
              {this.props.share.source && (
                <span className={styles.source}>{` ${this.props.share.createdBy &&
                  ` ${this.renderUserName(this.props.share.createdBy)}`
                  }`}</span>
              )}
            </div>

            <div className={styles.sharedByContainer}>
              <div md={4} className={styles.shareMetrics}>
                <div
                  className={cx(styles.metrics, {
                    [cx(styles.disabled, "contact_row_share_metrics__disabled")]:
                      !emailEvent,
                  })}
                >
                  {!emailEvent && <span className="paperflite-mail-open"></span>}

                  {emailEvent && (
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="tooltip">
                          Opened email last on{" "}
                          {dateformat(emailEvent.createdDate, "dd mmm yyyy")}
                        </Tooltip>
                      }
                    >
                      <span className="paperflite-mail-open"></span>
                    </OverlayTrigger>
                  )}
                </div>
                <div
                  className={cx(styles.metrics, {
                    [cx(styles.disabled, "contact_row_share_metrics__disabled")]:
                      !viewEvent,
                  })}
                >
                  {!viewEvent && <span className="paperflite-edit"></span>}

                  {viewEvent && (
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="tooltip">
                          Last clicked on a link on{" "}
                          {dateformat(viewEvent.createdDate, "dd mmm yyyy")}
                        </Tooltip>
                      }
                    >
                      <span className="paperflite-edit"></span>
                    </OverlayTrigger>
                  )}
                </div>
                <div
                  className={cx(styles.metrics, {
                    [cx(styles.disabled, "contact_row_share_metrics__disabled")]:
                      !collectionResharedEvent,
                  })}
                >
                  {!collectionResharedEvent && (
                    <span className="paperflite-share"></span>
                  )}

                  {collectionResharedEvent && (
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="tooltip">
                          Reshared {collectionResharedEvent.count} times, last on{" "}
                          {dateformat(
                            collectionResharedEvent.createdDate,
                            "dd mmm yyyy"
                          )}
                        </Tooltip>
                      }
                    >
                      <span className="paperflite-share"></span>
                    </OverlayTrigger>
                  )}
                </div>
              </div>
            </div>
          </div>
      </Row>
    );

    return (
      <Accordion className={styles.accordion}>
        <Accordion.Item eventKey="0">
          <Accordion.Header onClick={this._handleShareClicked}><Row className={styles.headerContainer}>
            <Col xl={12}>
              {header}
            </Col>
          </Row>
          </Accordion.Header>
          <Accordion.Body>
            <div className={styles.accordionBodyWrapper}>{this._renderChildren()}</div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  }

  getViewedEvent(events) {
    if (!events) {
      return null;
    }

    const viewEvents = events
      .filter((event) => {
        return (
          event.type === "collection_viewed" || event.type === "asset_viewed"
        );
      })
      .sort((e1, e2) => {
        return e2.createdDate - e1.createdDate;
      });

    if (viewEvents.length > 0) {
      return viewEvents[0];
    }
  }

  getEmailOpenEvent(events) {
    if (!events) {
      return null;
    }

    const viewEvents = events
      .filter((event) => {
        const source = this.props.share.source;
        return event.type === "email_open" || (event.type === "link_clicked" && source === "Paperflite QuickSend");
      })
      .sort((e1, e2) => {
        return e2.createdDate - e1.createdDate;
      });

    if (viewEvents.length > 0) {
      return viewEvents[0];
    }
  }

  renderUserName(user) {
    if (user.id && user.id === this.props.user.id) {
      return "me";
    } else {
      return `${user.firstName || ""} ${user.lastName || ""}`;
    }
  }
  _renderChildren() {
    if (this.props.share.fetching) {
      return <div className={styles.loading}>Loading details...</div>;
    }

    if (this.props.share.sections && this.props.share.sections.length > 0) {
      return this._renderSections();
    } else if (this.props.share.assets && this.props.share.assets.length > 0) {
      return this._renderAssets();
    }
  }

  _renderSections() {
    var sections = this.props.share.sections.map((section) => {
      return (
        <SectionShareView
          className={styles.section}
          key={section.id}
          shareId={this.props.share.id}
          contactId={this.props.contact}
          section={section}
          renderWithin="contact"
          conversation={this.props.share}
          fetchShareSection={this.props.fetchShareSection}
          fetchAssetAnalytics={this.fetchAssetAnalytics.bind(this)}
        />
      );
    });

    return sections;
  }

  _renderAssets() {
    var assets = this.props.share.assets.map((asset) => {
      return (
        <div>
          <AssetShareView
            key={asset.id}
            shareId={this.props.share.id}
            contactId={this.props.contact}
            page={this.props.page}
            className={styles.asset}
            asset={asset}
            renderWithin="contact"
            events={asset.events}
            shouldFetchAnalytics={true}
            fetchAssetAnalytics={this.fetchAssetAnalytics.bind(this)}
            showAnalytics={false}
          />
        </div>
      );
    });

    return assets;
  }

  padNumber(number = 0, pad) {
    number = Math.ceil(number);

    const length = pad - String(number).length + 1;
    let padding = "";
    if (length > 0) {
      padding = Array(pad - String(number).length + 1).join("0");
    }
    return padding + number;
  }

  timeSpentValue(timeSpent) {
    let timeSpentValue = `~${this.padNumber(timeSpent, 1)}s`;

    if (timeSpent >= 60) {
      timeSpentValue = `~${this.padNumber(Math.round(timeSpent / 60), 1)}m`;
    }

    return timeSpentValue;
  }
}

export default SharesView;